<template>

	<div class="page-report">

		<h3 class="page-report-title">
			Page Report for <span v-html="settings.keyword" /> on <span v-html="settings.url" />
		</h3>

		<div class="results">

			<h2 :class="{ 'result-heading': true, yes: this.settings.title }">In Title Tag</h2>

			<h2 :class="{ 'result-heading': true, yes: this.settings.description }">In Meta Description</h2>

			<h2 :class="{ 'result-heading': true, yes: this.settings.headerTags>0 }">In Header Tags</h2>

			<h2 :class="{ 'result-heading': true, yes: this.settings.content>0 }">In Content<span v-if="this.settings.content>0" v-html="' ('+( this.settings.content > 1 ? ( this.settings.content + ' times' ) : 'once' )+')'" /></h2>

		</div>

		<div class="current-wrap">

			<h3 class="current-title">Current Title Tag</h3>

			<p class="current-info" v-html="this.settings.titleContent===''?'**There is no Title Tag**':this.settings.titleContent" />

		</div>
		<div class="current-wrap">

			<h3 class="current-title">Current Meta Description</h3>

			<p class="current-info" v-html="this.settings.descriptionContent===''?'**There is no Meta Description**':this.settings.descriptionContent" />

		</div>
		<div class="current-wrap">

			<p class="word-count">This page contains approx. <span v-html="this.settings.wordCount + ' word' + ( this.settings.wordCount > 1 ? 's' : '' )" />.</p>

			<p class="generated">This report was generated <span v-html="generated" />, <span class="re-run" @click="reRunReport">click here to re-run it</span>.</p>

		</div>

	</div>

</template>

<script>
import general from './../utils/general.js'
export default {
	name: 'PageReport',
	props: ['settings'],
	data() {

		return {
			
		}

	},
	computed: { 
		generated () {

			return general.dateFormat( 'jS M Y @ g:i a', this.settings.created );

		}

    },
	methods: {

		reRunReport () {

			this.$emit( 'clicked', this.settings );

		}
		
	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_settings.less';
@import './../assets/css/less/_helper.less';
@imgRoot:'../assets/';
.close {

	width: 24px !important;
	height: 24px !important;
	background-size: 100% auto !important;

}

.page-report-title {

	font-size: 16px;
	margin: 20px 0 0;
	text-align: center;

	span {
		color: @formDefaultColour;
	}

}

.current-title, .current-info {
	padding: 0;
	margin: 0 auto;
	text-align: center;
	max-width: 800px;
	font-size: 15px;
}

.current-wrap {

	margin: 20px 20px 2px;
    background: white;
    padding: 15px;
    border-radius: 5px;

}

.results {

	text-align: center;

	.result-heading {

		position: relative;
		padding: 0 0 0 1.25em;
		font-size: 16px;
		display: inline-block;
		margin: 20px 15px 0;

		&:before {
			content: "❌";
			position: absolute;
			display: block;
			font-size: 0.65em;
			left: 0;
			top: 4px;
		}

		&.yes {

			&:before {

				content: "✔";
				color: #37b74a;
				font-size: 1em;
				top: 0;

			}

		}

	}

}

.generated, .word-count {

	padding:20px 0 5px 0;
	text-align: center;
	font-style: italic;
	font-size: 14px;
	margin: 0;

	.re-run {

		font-weight: @bold;
		color: @formDefaultColour;
		cursor: pointer;

		&:hover {

			text-decoration: underline;

		}

	}

}

.generated {

	opacity: 0.7;
	padding:5px 0 5px 0;

}

@media screen and (min-width: 480px) {
	.results {

		

	}
}
@media screen and (min-width: 960px) {
	.results {

		.result-heading {

			margin: 20px 30px 0 0;

		}

	}
	.page-report {

		padding: 0 20px;
	    max-width: 1000px;
	    margin: 20px auto;

	}
}
.generated {
	padding-bottom: 20px;
}
</style>